<input
  type="text"
  class="h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none focus:border-orange-400"
  [formControl]="reminderTitleControl"
  [placeholder]="'reminder_title' | translate"
/>
<app-input
  class="mt-3 block"
  [inputType]="'editor'"
  [formControl]="reminderControl"
  [placeholder]="'add_reminder' | translate"
/>
<div class="mt-3 flex items-center gap-2">
  <span class="shrink-0 text-sm text-slate-500">{{ 'reminder_assignee' | translate }}:</span>
  <app-select
    class="w-64"
    [formControl]="reminderAssignedControl"
    [options]="managers"
    optionLabel="name"
    optionValue="id"
    [isAvatar]="true"
    [showClear]="true"
    [appendTo]="'body'"
  />
</div>
<div class="mt-3 flex items-center gap-3">
  <p-datepicker
    styleClass="w-44 shrink-0"
    [fluid]="true"
    dataType="string"
    dateFormat="yy-mm-dd"
    [showButtonBar]="true"
    [appendTo]="'body'"
    panelStyleClass="board-v3-datepicker-panel"
    inputStyleClass="h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none focus:border-orange-400"
    [formControl]="reminderDateControl"
    [ariaLabel]="'reminder_date' | translate"
    (onSelect)="onReminderDateChange()"
    (onInput)="onReminderDateChange()"
    (onClear)="onReminderDateChange()"
  />
  <p-datepicker
    styleClass="w-28 shrink-0"
    [fluid]="true"
    dataType="string"
    [timeOnly]="true"
    hourFormat="24"
    [stepMinute]="1"
    [appendTo]="'body'"
    panelStyleClass="board-v3-datepicker-panel"
    inputStyleClass="h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none focus:border-orange-400 disabled:cursor-not-allowed disabled:bg-slate-50"
    [formControl]="reminderTimeControl"
    [ariaLabel]="'reminder_time' | translate"
  />
  <span class="shrink-0 text-sm text-slate-500">{{ 'reminder_notify' | translate }}</span>
  <button
    type="button"
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg! border border-slate-200 bg-white text-slate-500 hover:bg-slate-50"
    [attr.aria-label]="'reminder_notify' | translate"
    [cdkMenuTriggerFor]="reminderOffsetMenu"
  >
    <app-icon class="!h-5 !w-5 !text-[20px] !leading-5">notifications</app-icon>
  </button>
  <div class="flex-1"></div>
  <app-button
    [disabled]="!reminderTitleControl.value?.trim() || !reminderDateControl.value || !reminderTimeControl.value || submittingReminder"
    (onChangeClick)="submitReminder()"
  >
    {{ (editingReminderId ? 'reminder_edit_action' : 'send') | translate }}
  </app-button>
</div>

<ng-template #reminderOffsetMenu>
  <div cdkMenu class="min-w-56 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
    @for (option of reminderOffsetOptions; track option.value) {
      <button
        type="button"
        class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
        (click)="toggleReminderOffset(option.value)"
      >
        <app-icon
          class="!h-4 !w-4 !text-[16px] !leading-4"
          [ngClass]="isReminderOffsetSelected(option.value) ? 'text-blue-600' : 'text-transparent'"
        >check</app-icon>
        <span>{{ option.labelKey | translate }}</span>
      </button>
    }
  </div>
</ng-template>
